// Utility to test audio recording functionality
export const testAudioRecording = () => {
  console.log('Testing audio recording capabilities...');
  
  // Check if MediaRecorder is supported
  if (!window.MediaRecorder) {
    console.error('MediaRecorder is not supported in this browser');
    return false;
  }
  
  // Check if getUserMedia is supported
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    console.error('getUserMedia is not supported in this browser');
    return false;
  }
  
  console.log('✅ Audio recording is supported');
  return true;
};

// Test microphone permissions
export const testMicrophonePermission = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    console.log('✅ Microphone permission granted');
    stream.getTracks().forEach(track => track.stop()); // Clean up
    return true;
  } catch (error) {
    console.error('❌ Microphone permission denied:', error);
    return false;
  }
};

// Check browser compatibility
export const checkBrowserCompatibility = () => {
  const checks = {
    mediaRecorder: !!window.MediaRecorder,
    getUserMedia: !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia),
    webRTC: !!(window.RTCPeerConnection || (window as any).webkitRTCPeerConnection),
    audioContext: !!(window.AudioContext || (window as any).webkitAudioContext)
  };
  
  console.log('Browser compatibility check:', checks);
  return checks;
};
